exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntextarea[data-v-432da29c] {\n    border: solid 1px lightgray;\n}\n", ""]);

// exports
